"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeatherRelativeHumidityLevel = exports.WeatherAirQualityLevel = exports.WeatherUvIndexLevel = exports.WeatherConditions = exports.TemperatureUnit = void 0;
var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit["Celsius"] = "celsius";
    TemperatureUnit["Fahrenheit"] = "fahrenheit";
})(TemperatureUnit = exports.TemperatureUnit || (exports.TemperatureUnit = {}));
var WeatherConditions;
(function (WeatherConditions) {
    WeatherConditions["Blizzard"] = "blizzard";
    WeatherConditions["BlowingSand"] = "blowing_sand";
    WeatherConditions["Cloudy"] = "cloudy";
    WeatherConditions["Dry"] = "dry";
    WeatherConditions["Foggy"] = "foggy";
    WeatherConditions["FullMoon"] = "full_moon";
    WeatherConditions["Hail"] = "hail";
    WeatherConditions["HeavyRain"] = "heavy_rain";
    WeatherConditions["HeavyRainstorm"] = "heavy_rainstorm";
    WeatherConditions["HighTemperature"] = "high_temperature";
    WeatherConditions["LightRain"] = "light_rain";
    WeatherConditions["Lighting"] = "lightning";
    WeatherConditions["Mist"] = "mist";
    WeatherConditions["ModerateSnow"] = "moderate_snow";
    WeatherConditions["MoonCloudy"] = "moon_cloudy";
    WeatherConditions["PartlyCloudyDaytime"] = "partly_cloudy_daytime";
    WeatherConditions["PartlyCloudyNight"] = "partly_cloudy_night";
    WeatherConditions["Rainbow"] = "rainbow";
    WeatherConditions["Sandstorm"] = "sandstorm";
    WeatherConditions["Snowy"] = "snowy";
    WeatherConditions["SunCloudy"] = "sun_cloudy";
    WeatherConditions["Sunny"] = "sunny";
    WeatherConditions["Thunderstorm"] = "thunderstorm";
    WeatherConditions["Typhoon"] = "typhoon";
    WeatherConditions["Wet"] = "wet";
})(WeatherConditions = exports.WeatherConditions || (exports.WeatherConditions = {}));
var WeatherUvIndexLevel;
(function (WeatherUvIndexLevel) {
    WeatherUvIndexLevel["Low"] = "low";
    WeatherUvIndexLevel["Moderate"] = "moderate";
    WeatherUvIndexLevel["High"] = "high";
    WeatherUvIndexLevel["VeryHigh"] = "very_high";
    WeatherUvIndexLevel["Extreme"] = "extreme";
})(WeatherUvIndexLevel = exports.WeatherUvIndexLevel || (exports.WeatherUvIndexLevel = {}));
var WeatherAirQualityLevel;
(function (WeatherAirQualityLevel) {
    WeatherAirQualityLevel["Good"] = "good";
    WeatherAirQualityLevel["Moderate"] = "moderate";
    WeatherAirQualityLevel["Unhealthy"] = "unhealthy";
    WeatherAirQualityLevel["VeryUnhealthy"] = "very_unhealthy";
})(WeatherAirQualityLevel = exports.WeatherAirQualityLevel || (exports.WeatherAirQualityLevel = {}));
var WeatherRelativeHumidityLevel;
(function (WeatherRelativeHumidityLevel) {
    WeatherRelativeHumidityLevel["Dry"] = "dry";
    WeatherRelativeHumidityLevel["Normal"] = "normal";
    WeatherRelativeHumidityLevel["SlightlyHumid"] = "slightly_humid";
    WeatherRelativeHumidityLevel["Humid"] = "humid";
    WeatherRelativeHumidityLevel["VeryHumid"] = "very_humid";
})(WeatherRelativeHumidityLevel = exports.WeatherRelativeHumidityLevel || (exports.WeatherRelativeHumidityLevel = {}));
